import React, { useEffect, useState } from 'react';
import { RefreshCw, Wifi, WifiOff } from 'lucide-react';

/**
 * Compacto indicador de sincronización que va en la sidebar.
 * Muestra "hace X" desde la última sincronización + botón manual + estado online.
 */
const relative = (iso) => {
  if (!iso) return 'Nunca';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 5) return 'Justo ahora';
  if (diff < 60) return `Hace ${Math.floor(diff)}s`;
  if (diff < 3600) return `Hace ${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `Hace ${Math.floor(diff / 3600)}h`;
  return new Date(iso).toLocaleString('es-ES', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' });
};

const SyncIndicator = ({ status, onSyncNow }) => {
  const [, setTick] = useState(0);
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  // Tick para refrescar el "hace X"
  useEffect(() => {
    const t = setInterval(() => setTick((v) => v + 1), 15000);
    return () => clearInterval(t);
  }, []);

  // Estado online/offline
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  const relLabel = relative(status?.lastSyncAt);

  return (
    <div className="px-3 py-2 border-t border-white/10 text-xs">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 min-w-0" data-testid="sync-status">
          {online ? (
            <Wifi size={12} className="text-[#A3FF12]/70 flex-shrink-0" />
          ) : (
            <WifiOff size={12} className="text-red-400 flex-shrink-0" />
          )}
          <span className="text-white/50 truncate">
            {online ? 'Sync' : 'Sin conexión'} · <span className="text-white/70">{relLabel}</span>
          </span>
        </div>
        <button
          onClick={onSyncNow}
          disabled={status?.syncing}
          data-testid="sync-now-btn"
          title="Sincronizar ahora"
          className="p-1.5 rounded-lg text-white/50 hover:text-[#A3FF12] hover:bg-white/5 transition-colors disabled:opacity-40"
        >
          <RefreshCw size={13} className={status?.syncing ? 'animate-spin' : ''} />
        </button>
      </div>
    </div>
  );
};

export default SyncIndicator;
